export default {
  services: /(newsitems|filters|eventreports)/,
  version: "v1",
  appName: "select"
};
